<template>
  <div class="match-making">
    <loader-full></loader-full>
  </div>
</template>
<script>
import LoaderFull from "../Loaders/LoaderFull.vue";
import firebase from "./../../firebase/firebase.js";
import Firebase from "firebase";
import moment from "moment";
import decodeApi from "../../api/decode.js";
moment.locale("pt-br");
export default {
  components: {
    LoaderFull
  },
  data() {
    return {
      timeoutId: ""
    };
  },
  async created() {
    const db = await firebase.constructDB();
    const {
      sessionId,
      player,
      scheduleTime
    } = await this.$store.getters.getSimple([
      "sessionId",
      "player",
      "scheduleTime"
    ]);
    const playerInLobby = await this.playerInLobby(db, sessionId, player);
    if (!playerInLobby) {
      await this.joinLobby(db, sessionId, player);
    }
    setTimeout(() => {
      this.watchLobby(db, sessionId, player);
    }, 4000);
  },
  methods: {
    async playerInLobby(db, sessionId, player) {
      const lobbySession = await db
        .collection("lobbies")
        .doc(sessionId)
        .get();
      let players = [];
      let exists = false;
      if (lobbySession.exists) {
        players = lobbySession.data().players;
      }
      if (players.length > 0) {
        players.forEach(playerLobby => {
          if (playerLobby.id == player.id) {
            exists = true;
          }
        });
      }
      return exists;
    },
    async joinLobby(db, sessionId, player) {
      const ref = db.collection("lobbies").doc(sessionId);
      const now = Firebase.firestore.Timestamp.now();
      delete player.cpf;
      player.createdAt = now;
      ref.update({
        players: Firebase.firestore.FieldValue.arrayUnion(player)
      });
      return;
    },
    async watchLobby(db, sessionId, player) {
      let self = this;
      let callCreate = false;
      db.collection("lobbies")
        .doc(sessionId)
        .onSnapshot(async snapshot => {
          const { players } = snapshot.data();
          const playerInLobby = players.some(playerGroup => {
            return player.id == playerGroup.id;
          });
          const logicIndex = await self.defineLogicIndex(players, player);
          // const createGroup = await self.verifyLogicGroup(players.length, logicIndex)
          // if(createGroup){
          if (!callCreate && playerInLobby) {
            callCreate = true;
            // console.log("players.length: ", players.length);
            // const lastGroup = Math.trunc((players.length - 1) / 4)
            const playerGroup = Math.trunc(logicIndex / 4);
            // console.log(lastGroup)
            const defineLogicGroup = await self.defineLogicGroup(
              logicIndex,
              players,
              player
            );
            // console.log("defineLogicGroup: ", defineLogicGroup);
            const indexPlayer = await self.indexPlayer(
              logicIndex,
              defineLogicGroup,
              player
            );
            // console.log("indexPlayer: ", indexPlayer);
            self.sortHost(
              db,
              defineLogicGroup,
              player,
              sessionId,
              logicIndex,
              playerGroup,
              indexPlayer
            );
            self.watchGroup(
              db,
              sessionId,
              player,
              logicIndex,
              playerGroup,
              indexPlayer
            );
          }
        });
    },
    defineLogicIndex(players, currentPlayer) {
      let logicIndex = 0;
      players.forEach((player, index) => {
        if (player.id == currentPlayer.id) logicIndex = index;
      });
      return logicIndex;
    },
    verifyLogicGroup(lengthLobby, logicIndex) {
      // se o createLastGroup for true : ele cria o grupo
      // se não for ele verifica se o player está no ultimo grupo
      // se tiver ele não cria
      // se tiver ele cria
      const createLastGroup = (lengthLobby / 4) % 1 === 0; // verifica se o ultimo grupo já tem 4 pessoas
      const playerGroup = Math.trunc(logicIndex / 4); // grupo do player
      const lastGroup = Math.trunc(lengthLobby / 4); // index do grupo dele

      if (createLastGroup || playerGroup != lastGroup) {
        // console.log("cria o grupo");
        // cria o grupo
        return true;
      }
      return false;
      // console.log("nao cria o grupo");
    },
    defineLogicGroup(logicIndex, players, player) {
      const playerGroup = Math.trunc(logicIndex / 4);
      const logicGroup = players.filter((player, index) => {
        return Math.trunc(index / 4) == playerGroup;
      });

      return logicGroup;
    },
    async indexPlayer(logicIndex, logicGroup, player) {
      let indexPlayer = "";
      const playerGroup = Math.trunc(logicIndex / 4);
      logicGroup.forEach((playerGroup, index) => {
        if (playerGroup.id == player.id) indexPlayer = index;
      });
      return indexPlayer;
    },
    async sortHost(
      db,
      logicGroup,
      player,
      sessionId,
      logicIndex,
      lastGroup,
      indexPlayer
    ) {
      const { scheduleTime } = await this.$store.getters.getSimple([
        "scheduleTime"
      ]);
      const startedAt = await this.defineStartedAt(scheduleTime);
      const groupId = `${sessionId}${lastGroup}`;
      const group = await db
        .collection("groups")
        .doc(groupId)
        .get();
      if (group.data() && group.data().teamGameId) {
        return;
      }
      this.timeoutId = setTimeout(async () => {
        const grupo = await db
          .collection("groups")
          .doc(groupId)
          .get();
        if (!grupo.exists) {
          let objectRequest = {};
          objectRequest.startedAt = startedAt;
          objectRequest.sessionId = sessionId;
          objectRequest.players = [player];
          objectRequest.groupId = groupId;
          // console.log("objectRequest: ", objectRequest);
          const response = await decodeApi.post("/matchmaking", objectRequest);
          // console.log("response.data: ", response.data);
        }
      }, 10000 * indexPlayer);
    },
    async watchGroup(
      db,
      sessionId,
      player,
      logicIndex,
      lastGroup,
      indexPlayer
    ) {
      const groupId = `${sessionId}${lastGroup}`;
      const self = this;
      const getGroup = db
        .collection("groups")
        .doc(groupId)
        .onSnapshot(async snapshot => {
          if (snapshot.exists) {
            clearTimeout(self.timeoutId._id);
            clearTimeout(self.timeoutId);
            getGroup();
            self.$store.dispatch("simpleSave", {
              group: snapshot.data().players,
              groupId: groupId
            });
            const players = snapshot.data().players;
            const inGroup = players.some(playerGroup => {
              return playerGroup.id == player.id;
            });
            if (!inGroup) {
              await self.pushPlayerGroup(db, player, groupId, indexPlayer);
              return;
            }
            self.$router.push("/chat-initial");

            return;
          }
          // console.log("ainda não tem grupo");
        });
    },
    async pushPlayerGroup(db, player, groupId, indexPlayer) {
      const colors = ["#873AD8", "#009DFF", "#9edac2", "#FF9800", "#42d90b"];
      player.color = colors[indexPlayer];
      player.score = 3000;
      delete player.cpf;
      await db
        .collection("groups")
        .doc(groupId)
        .update({
          players: Firebase.firestore.FieldValue.arrayUnion(player)
        });
      this.$router.push("/chat-initial");

      return;
    },
    defineStartedAt(sessionSchedule) {
      let momentSchedule = moment(sessionSchedule).add(15, "minutes");
      momentSchedule = momentSchedule.format();
      return momentSchedule;
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
